define([
	"dojo/_base/declare",
	"dojo/_base/lang",
	"csi",
	"csi/_base/modules",
	"csi/def",
	"csi/def/Field",
	"csi/form/Widget",
	"csi/xml"
], function(declare,lang,csi,modules,def,Field,Widget,xml) {

	return declare(Widget, {
		_resolveView: function() {
			// summary: add specification and create-quote fields
			if (this.isCreateForm()) {
				//Add the PA Spec field only on create new, not on copy form
				this.insertField(lang.mixin(new Field(), {
					m_id: "ThemePASpec",
					m_onChange: "_onChangeSpecification"
				}), 0);
			}

//			if (modules.hasModule("Sourcing") && this.isCreateForm()) {
//				// we're doing a create, not a copy
//				this.insertField(lang.mixin(new Field(), {
//					m_label: "CreateQuote",
//					m_typeControl: def.FIELD_CHECKBOX
//				}));
//			}

			this.inherited(arguments);
		},

		_onChangeSpecification: function(/*csi.def.View*/defView, /*Field*/field, /*Any*/value) {
			// summary: update fields based on specification
			var spec = (value == csi.EMPTY_URL) ? null : this.cacheView.getNode(value, true);

			var createQuoteField = this.defView.getField("CreateQuote");
			if (createQuoteField) {
				this.setFieldValue(createQuoteField, spec && spec.SupplierQuoteExpected, true);
			}

			var nameField = this.defView.getField(xml.ATTR_NAME);
			if (nameField.isDefaultValue())
				this.setFieldValue(nameField, spec ? spec.$Name : "", true);
		}
	});
});